import React from "react";
import { ToastContainer } from "react-toastify";
import FooterFooter from "../../components/footerfooter";
//IMPORT DYNAMIC STYLED COMPONENT
import { StyledHeader } from "../../Styles";
import "./styles/newDashboard.scss";

//SWITCH VARIABLE FOR PAGE STYLE
const theme = "GREY"; //LIGHT, GREY, RETRO
const NewDashboard = () => {
  return (
    <>
      <div className="greyscheme main_wrapper">
        <StyledHeader theme={theme} />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          theme="dark"
          pauseOnHover
        />
        <div className="greyscheme">
          <div className="hero_section">
            <section className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="top_title">
                    <p>Moose Society</p>
                    <h1 data-aos="fade-up" data-aos-delay="200" data-aos-duration="5000" data-aos-once="true" data-aos-easing="ease-in-out">Holder Dashboard</h1>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="middle_title">
                    <p>WHAT DO YOU WANT TO DO TODAY?</p>
                  </div>
                </div>
              </div>
              <div className="row">
                {items.map((d, i) => (
                  <div key={i + 1} className="col-md-3" data-aos="fade-up" data-aos-delay={`${i+5}00`}  data-aos-duration="5000" data-aos-once="true" data-aos-easing="ease-out-cubic">
                    <div className="box">
                      <div className="box_text">
                        <h3>{d}</h3>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          </div>
          <br />
          <br />
          <FooterFooter />
        </div>
      </div>
    </>
  );
};

export default NewDashboard;

const items = [
  "MINT AN OG MOOSE",
  "STAKE A PAIR",
  "ISLAND BANK",
  "MARKETPLACE",
  "CLAIM A SOCIETY HIDEOUT",
  "MINT A HERO BOX",
  "MINT A MUTANT SERUM",
  "EVOLVE A MINI MOOSE",
];
